'use client';

import { Text as ChakraText } from '@chakra-ui/react';
import type { TextProps as ChakraTextProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

export interface TextProps
  extends Omit<
    ChakraTextProps,
    // Remove Chakra v2 shorthand props
    | 'w'
    | 'h'
    | 'minW'
    | 'maxW'
    | 'p'
    | 'pt'
    | 'pr'
    | 'pb'
    | 'pl'
    | 'px'
    | 'py'
    | 'm'
    | 'mt'
    | 'mr'
    | 'mb'
    | 'ml'
    | 'mx'
    | 'my'
  > {
  // Typography-specific props
  fontSize?: ChakraTextProps['fontSize'];
  fontWeight?: ChakraTextProps['fontWeight'];
  lineHeight?: ChakraTextProps['lineHeight'];
  letterSpacing?: ChakraTextProps['letterSpacing'];
  textAlign?: ChakraTextProps['textAlign'];
  color?: ChakraTextProps['color'];
  // Layout props with full names only
  width?: ChakraTextProps['width'];
  margin?: ChakraTextProps['margin'];
  marginTop?: ChakraTextProps['marginTop'];
  marginRight?: ChakraTextProps['marginRight'];
  marginBottom?: ChakraTextProps['marginBottom'];
  marginLeft?: ChakraTextProps['marginLeft'];
  padding?: ChakraTextProps['padding'];
}

/**
 * Text component for rendering text content with typography styles.
 *
 * @example
 * <Text fontSize="lg" fontWeight="bold" color="#1F2937">
 *   Hello World
 * </Text>
 */
export const Text = forwardRef<HTMLParagraphElement, TextProps>((props, ref) => {
  return <ChakraText ref={ref} {...props} />;
});

Text.displayName = 'Text';
